<template>
    <div>
        <v-container fluid class="pa-0">
            <v-layout row wrap class="pages-wrapper">
                <v-flex xs12 v-if="journal">
                    <JournalHeader
                        :mediaLogo="journal.media.logoLink"
                        :mediaName="journal.media.name"
                        :journalType="journal.type"
                        :publishDate="journal.publishDate"
                        :keywords="searchFilter.keywords"
                    />
                </v-flex>
                <v-flex :key="page.pageId" v-for="page in loadedPages">
                    <v-card>
                        <v-card-title class="pa-1">
                            <span class="ml-3 body-2 primary--text">{{ page.pageNo | pageNoText }}</span>
                            <v-spacer></v-spacer>
                            <v-btn 
                                v-if="isSuperAdmin || isBindezAdmin"
                                flat 
                                icon 
                                small 
                                @click="() => downloadPageContent(page.pageId)"
                            >
                                <v-icon small>save_alt</v-icon>
                            </v-btn>
                            <v-btn flat @click="() => goClipping(page.pageId)">Add to Report</v-btn>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <page :item="page" />
                        </v-card-text>
                    </v-card>
                </v-flex>
                <v-flex xs12 v-if="loading">
                    <v-card>
                        <div class="progress-wrapper">
                            <v-progress-linear :indeterminate="true"></v-progress-linear>
                        </div>
                    </v-card>
                </v-flex>
            </v-layout>
            <div
                v-infinite-scroll="loadNextPage"
                infinite-scroll-distance="10"
                infinite-scroll-disabled="scrollLoadDisabled"
            ></div>
        </v-container>
    </div>
</template>

<script>
    import Page from '@/components/Page'
    import { mapActions, mapState, mapMutations } from 'vuex';
    import custom_date from '../mixins/custom_date';
    import keywords from '../mixins/keywords';
    import page from "../mixins/page";
    import JournalHeader from "@/components/JournalHeader";
    import current_user from '@/mixins/current_user';
    import { forceDownload } from '@/utils/file.utils'
    import axios from 'axios'

    export default {
        components: {
            Page,
            JournalHeader,
        },

        mixins: [
            custom_date,
            keywords,
            page,
            current_user,
        ],

        data() {
            return {
                pageSize: 100,
            }
        },

        created() {
            this.loading = true;
            
            this.fetchJournal({ 
                id: this.journalId, 
                filter: this.searchFilter 
            })
            .finally(() => this.loading = false);
        },

        methods: {
            getWordsForPage(page) {
                const { keywords } = this.searchFilter;
                return this.fetchMatchedWords({ page, keywords });
            },

            ...mapActions('journal_details', [
                'fetchJournal',
                'fetchMatchedWords',
                'getPageContent',
            ]),

            ...mapMutations('journal_details', [
                'setLoading'
            ]),

            async loadNextPage() {
                if (this.journal && !this.loading) {
                    if (this.journal.pages.length > this.loadedPages.length) {

                        this.loading = true;

                        const nextPage = this.journal.pages[this.loadedPages.length];
                        if (nextPage) {
                            await this.getWordsForPage(nextPage);
                        }
                        
                        this.loading = false;
                    }
                }
            },

            goClipping(pageID) {
                const param = { 
                    name: "clipping", 
                    params: { id: pageID }, 
                };

                const { keywords } = this.searchFilter;
                if (keywords != undefined && keywords.length > 0) {
                    param.query = { keywords };
                }
                
                const routeData = this.$router.resolve(param);
                window.open(routeData.href, '_blank');
            },

            downloadPageContent(page_id) {
                this.getPageContent(page_id)
                    .then(res => {
                        const url = res.data
                        axios({
                            method: 'get',
                            url,
                            responseType: 'arraybuffer',
                        })
                            .then(res => forceDownload(res, url))
                    })

                this.$ua.trackEvent('DownloadPageContent', 'click',
                    `${this.currentUser.username || 'User'} downloaded ${page_id}`);
            },
        },

        computed: {
            journalId() {
                return this.$route.params.id
            },

            searchFilter() {
                let { keywords } = this.$route.query;

                keywords = keywords ? keywords : [];
                keywords = Array.isArray(keywords) ? [...keywords] : [keywords];

                return {
                    keywords,
                    mediaIds: [] // API accepts an array only.
                };
            },

            pageSizeInPercent() {
                return `${this.pageSize}%`
            },

            loading: {
                get() {
                    return this.$store.state.journal_details.loading;
                },

                set(isloading) {
                    this.setLoading(isloading);
                }
            },

            scrollLoadDisabled() {
                if (this.journal) {
                    return this.loading 
                        || this.journal.pages.length === this.loadedPages.length;
                } else {
                    return true;
                }
            },

            ...mapState('journal_details', [
                'journal',
                'loadedPages'
            ])
        },
    }
</script>

<style scoped>
    .fab-add {
        margin-bottom: 50px;
    }

    .pages-wrapper {
        overflow-y: scroll;
    }

    .progress-wrapper {
        padding: 5px 20px;
    }

    .media-meta {
        margin-left: 20px;
    }
</style>
